import type { JSX } from 'react';
import { InspectionCard } from './InspectionCard';
import type { InspectionVerification } from '../types/inspection.types';

interface InspectionListProps {
  verifications: InspectionVerification[];
  isLoading: boolean;
  isProcessing?: boolean;
  emptyMessage?: string;
  onApprove: (verificationId: string) => void;
  onReturn: (verification: InspectionVerification) => void;
}

export function InspectionList({
  verifications,
  isLoading,
  isProcessing = false,
  emptyMessage = 'No verifications awaiting inspection',
  onApprove,
  onReturn,
}: InspectionListProps): JSX.Element {
  if (isLoading) {
    return <div className="text-center py-8 text-muted-foreground">Loading verifications...</div>;
  }

  if (verifications.length === 0) {
    return <div className="text-center py-8 text-muted-foreground">{emptyMessage}</div>;
  }

  return (
    <div className="grid gap-4">
      {verifications.map((verification) => (
        <InspectionCard
          key={verification.id}
          verification={verification}
          isProcessing={isProcessing}
          onApprove={onApprove}
          onReturn={onReturn}
        />
      ))}
    </div>
  );
}
